import React from 'react';

import './rightSidebar.css';

const AddProjectComponent = () => {
  return (
    <div className="sidebar-container help-sidebar">
      <p className="light-grey-text">HELP</p>
      <h1 className="title">Add a project</h1>
      <ul className="categoried-list">
        <li>Experience in technical projects is one of the biggest things engineering managers look for when deciding who to hire.</li>
        <li>If you are unsure of what to write, click on each section and you will see helpful examples.</li>
      </ul>
    </div>
  );
};

export default AddProjectComponent;
